<!--<template>
    <b-dropdown id="ddown1" text="Show Activity" class="m-md-2 show-activity">
        <b-dropdown-item href="#">Cras justo odioCras justo odioCras justo odioCras justo odio</b-dropdown-item>
        <b-dropdown-item href="#">Cras justo odioCras justo odioCras justo odioCras justo odio</b-dropdown-item>
        <b-dropdown-item href="#">Cras justo odioCras justo odioCras justo odioCras justo odio</b-dropdown-item>
        <b-dropdown-item href="#">Cras justo odioCras justo odioCras justo odioCras justo odio</b-dropdown-item>
        <b-dropdown-item href="#">Cras justo odioCras justo odioCras justo odioCras justo odio</b-dropdown-item>
        <b-dropdown-item href="#">Cras justo odioCras justo odioCras justo odioCras justo odio</b-dropdown-item>
        <b-dropdown-item href="#">Cras justo odioCras justo odioCras justo odioCras justo odio</b-dropdown-item>
        <b-dropdown-item href="#">Cras justo odioCras justo odioCras justo odioCras justo odio</b-dropdown-item>
        <b-dropdown-item href="#">Cras justo odioCras justo odioCras justo odioCras justo odio</b-dropdown-item>
        <b-dropdown-item href="#">Cras justo odioCras justo odioCras justo odioCras justo odio</b-dropdown-item>
        <b-dropdown-item href="#">Cras justo odioCras justo odioCras justo odioCras justo odio</b-dropdown-item>
        <b-dropdown-item href="#">Cras justo odioCras justo odioCras justo odioCras justo odio</b-dropdown-item>
        <b-dropdown-item href="#">Cras justo odioCras justo odioCras justo odioCras justo odio</b-dropdown-item>

        <b-dropdown-item href="#">Show All Activity</b-dropdown-item>
    </b-dropdown>
</template>-->

<script>
export default {
  name: 'ShowActivity',
  props: { /* set prop from parent component */
  }
}
</script>

<style scoped>
.show-activity .dropdown-item {
  width: 300px;
  white-space: normal;
}
</style>

<style>
.show-activity .dropdown-menu {
  max-height: 80vh;
  top: 20vh;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/ShowActivity.vue